import React from 'react';
import { isMultilineAddressField } from '../../../../services/multiline-address';
import { isInputField, isNestedFormField } from '../../types';
import { InputField } from './input-field';
import { NestedFormField } from './nested-form-field';
import { ReadOnlyField } from './read-only-field';
import { SubmitButtonField } from './submit-button-field';
export const FormField = ({ field, FieldLayout, ...rest })=>{
    if (!isMultilineAddressField(field) && isNestedFormField(field)) {
        return /*#__PURE__*/ React.createElement(NestedFormField, {
            ...rest,
            field: field,
            FieldLayout: FieldLayout
        });
    }
    if (isInputField(field)) {
        return /*#__PURE__*/ React.createElement(InputField, {
            ...rest,
            field: field,
            FieldLayout: FieldLayout
        });
    }
    if (field.fieldType === 'SUBMIT_BUTTON') {
        return /*#__PURE__*/ React.createElement(SubmitButtonField, {
            ...rest,
            field: field,
            FieldLayout: FieldLayout
        });
    }
    return /*#__PURE__*/ React.createElement(ReadOnlyField, {
        ...rest,
        field: field,
        FieldLayout: FieldLayout
    });
};

//# sourceMappingURL=form-field.js.map